import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppsRoutingModule } from './apps-routing.module';
import { AppsComponent } from './apps.component';
import { SharedModule } from '../shared/shared.module';
import { AppComponent } from './app/app.component';
import { DateAgoPipe } from '../shared/pipes/date-ago.pipe';
import { AppSettingsComponent } from './app/app-modals/app-settings/app-settings.component';
import { AppUpdateComponent } from './app/app-modals/app-update/app-update.component';
import { AppInstallComponent } from './app/app-modals/app-install/app-install.component';
import { AppUninstallComponent } from './app/app-modals/app-uninstall/app-uninstall.component';
import { AppCalendarConflictComponent } from './app/app-modals/app-calendar-conflict/app-calendar-conflict.component';
import { FileFieldComponent } from './app/file-field/file-field.component';
import { CrmLeadFiltersComponent } from './app/crm-lead-filters/crm-lead-filters.component';
import { YelpZapierSetupComponent } from './app/yelp-zapier-setup/yelp-zapier-setup.component';
import { YelpZapierCallbackComponent } from './app/yelp-zapier-setup/yelp-zapier-callback.component';
import { heroAdjustmentsHorizontal, heroArrowPath, heroArrowUpRight, heroArrowUturnLeft, heroCalendarDays, heroCheck, heroCheckCircle, heroCog6Tooth, heroDevicePhoneMobile, heroDocumentText, heroExclamationTriangle, heroInformationCircle, heroLinkSlash, heroMapPin, heroPlusCircle, heroShoppingBag, heroShoppingCart, heroSquare2Stack, heroXCircle } from '@ng-icons/heroicons/outline';
import { NgIconsModule } from '@ng-icons/core';


@NgModule({
  declarations: [
    AppsComponent,
    AppComponent,
    AppSettingsComponent,
    AppUpdateComponent,
    AppInstallComponent,
    AppUninstallComponent,
    AppCalendarConflictComponent,
    FileFieldComponent,
    CrmLeadFiltersComponent,
    YelpZapierSetupComponent,
    YelpZapierCallbackComponent
  ],
  imports: [
    CommonModule,
    AppsRoutingModule,
    SharedModule,
    NgIconsModule.withIcons({
      heroAdjustmentsHorizontal, heroArrowUturnLeft, heroLinkSlash, heroCog6Tooth, heroInformationCircle, heroPlusCircle, heroArrowPath, heroArrowUpRight, heroCalendarDays, heroShoppingCart, heroShoppingBag, heroXCircle, heroMapPin, heroDevicePhoneMobile, heroDocumentText, heroCheck, heroCheckCircle, heroSquare2Stack, heroExclamationTriangle
    }),
  ],
  exports: [],
  providers: [DateAgoPipe]
})
export class AppsModule {
}
